import { StoreType } from '@frodo/models/types';

type PriceFormatOptions = {
  showPrefix?: boolean;
  customPrefix?: string;
  isSimpleFormat?: boolean;
  maximumFractionDigits?: number;
};

export const centsToDecimal = (cents: number): number => cents / 100;

const createPriceFormatter = (store: StoreType) => {
  const baseFormatter = new Intl.NumberFormat(store.currencyLocale, {
    style: 'currency',
    currency: store.currencyIsoCode,
  });

  return (price: number, options: PriceFormatOptions = {}): string => {
    const {
      customPrefix,
      showPrefix = false,
      maximumFractionDigits,
      isSimpleFormat = false,
    } = options;

    // create new formatter if maximumFractionDigits is provided
    const formatter =
      maximumFractionDigits !== undefined
        ? new Intl.NumberFormat(store.currencyLocale, {
            style: 'currency',
            currency: store.currencyIsoCode,
            maximumFractionDigits,
            minimumFractionDigits: maximumFractionDigits,
          })
        : baseFormatter;

    let formatted = formatter.format(price / 100);

    // Remove comma/dot and currency sign if isSimpleFormat is true
    if (isSimpleFormat) {
      formatted = formatted.replace(/[^\d\s-]/g, '').trim();
    }

    if (!showPrefix) return formatted;

    return `${customPrefix ?? store.priceRangePrefix} ${formatted}`;
  };
};

export const currencyManager = (store: StoreType) => ({
  formatPrice: createPriceFormatter(store),
});
